'use client'

import Schedule from '@/components/schedule'
import { useTournament } from '@/hooks/useTournament'

export default function SchedulePage() {
  const savedTournament = useTournament()

  if (!savedTournament) return null

  return (
    <Schedule savedTournament={savedTournament} />
  )
}
